import {useRouteLoaderData} from '@remix-run/react'
import {getDomainConfig} from '~/domains'

import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types/index.js'

export default function Disclaimer() {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {camelCaseUrl} = getDomainConfig(domain, locale)
  const translations = getTranslation(language)

  return (
    <div
      className="mb-9 mt-10 px-4 text-[14px] desktop:px-64 tablet:px-10 mobile:mt-12 xs-mobile:mt-14"
      data-testid="disclaimer-page"
    >
      <label className="mt-24 text-5xl">{translations.Disclaimer(camelCaseUrl).title}</label>
      <hr className="mb-10 mt-10 h-1 w-full bg-gray-400" />
      <div className="text-sm">
        <p className="mb-6">{translations.Disclaimer(camelCaseUrl).p1}</p>
        <p className="mb-6">{translations.Disclaimer(camelCaseUrl).p2}</p>
        <p className="mb-6">{translations.Disclaimer(camelCaseUrl).p3}</p>
        <p className="mb-6">{translations.Disclaimer(camelCaseUrl).p4}</p>
      </div>
    </div>
  )
}
